<template>
  <div class="homeContent">
    <div
      class="topNews"
      v-if="oshirase"
      @click="onMessageList()">
      あなたへのお知らせがあります
    </div>
    <div class="mainvisual" v-if="mainVisual && mainVisual.length >= 2">
      <div
        v-for="(item, index) in mainVisual"
        :key="index"
        class="bg"
        :style="getMainvisualStyle(index, item.imgPath, mainVisual.length)"/>
    </div>
    <!-- メインビジュアルが1枚だけの時 -->
    <div class="mainvisual" v-else-if="mainVisual && mainVisual.length === 1">
      <div class="bg --opacityOne" :style="`background-image: url(${getImg(mainVisual[0].imgPath)});`" />
    </div>

    <div class="topBunner" v-if="topBunner">
      <img
        :src="getImg(topBunner.imgPath)"
        @click="onCampaign(topBunner.type, topBunner.optionId01, topBunner.url)">
    </div>

    <div v-if="bannerImagePath && dialogType !== 0" class="topBunner" @click="openPitDialog()">
      <img :src="getImg(bannerImagePath)">
    </div>

    <div class="campaign" v-if="campaignList && campaignList.length">
      <section-header heading="2" ja="ピックアップ"/>
      <div class="campaignArea">
        <ul class="campaignList" :style="'width:' + campaignList.length * 187 + 'px; min-width: 375px;'">
          <li v-for="item in campaignList" :key="item.id">
            <button @click="onCampaign(item.type, item.optionId01, item.url)">
              <img :src="getImg(item.imgPath)">
            </button>
          </li>
        </ul>
      </div>
    </div>

    <div class="storeLink">
      <a
        href="https://apps.apple.com/jp/app/%E3%83%97%E3%83%AA%E3%82%AF%E3%83%A9on/id1491707486?l=en&amp;itsct=apps_box&amp;itscg=30200">
        <img
          class="appstore"
          src="../assets/Png/top/appstore.png"
          alt="Download on the App Store" />
      </a>
      <a
        href='https://play.google.com/store/apps/details?id=com.sega.puri&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
        <img
          class="googleplay"
          alt='Google Play で手に入れよう'
          src='../assets/Png/top/googleplay.png' />
      </a>
    </div>

    <div class="appliText">
      <div class="appliText-inner">
        アプリ版プリクラONでは下記の機能がご利用いただけます。<br>
        ・QRでのプリダウンロード<br>
        ・アルバムでのプリのらくがき、背景、メイクのON/OFF<br>
        ・プリもっとのご利用<br>
        ・ARプリクラのご利用
      </div>
      <normal-btn @click="hasAppli = true">詳細はこちら</normal-btn>
    </div>

    <div class="news">
      <section-header heading="2" ja="みんなへのお知らせ"/>
      <div
        v-for="(item,index) in messageList"
        :key="index"
        class="item"
        @click="onMessageDetail(item.id)">
        <news-list-item
          v-if="index < 3"
          :title="item.title"
          :start-date="item.startDate"
          :end-date="item.endDate"
          :img-flg="item.imgFlg"
          :image-path="item.imgPath"
          :is-new="isNew(item.startDate)"/>
      </div>
      <div
        v-for="(item,index) in newsList"
        :key="index"
        class="item"
        @click="onNewsDetail(item.id)">
        <news-list-item
          v-if="index < 3"
          :title="item.title"
          :start-date="item.startDate"
          :end-date="item.endDate"
          :img-flg="item.imgFlg"
          :image-path="item.imgPath"
          :is-new="isNew(item.startDate)"/>
      </div>
      <normal-btn @click="onNewsList()">みんなへのお知らせ一覧</normal-btn>
    </div>
    <div class="puriki">
      <div class="purikiTitle">
        <section-header heading="2" ja="プリ機一覧"/>
        <div class="linkText" @click="onLocation">遊べるお店はこちら</div>
      </div>
      <div class="purikiArea">
        <ul class="purikiList" :style="'width: ' + purikiList.length * 120 + 'px;'">
          <li v-for="(item, index) in purikiList" :key="index">
            <button
              class="puriBtn"
              :class="{ 'new': item.isDisplayNew }"
              @click="onKoutaiLink(item.informationUrl)">
              <img :src="getImg(item.arcadeImg)">
            </button>
            <div class="puriTitle">{{item.name}}</div>
          </li>
        </ul>
      </div>
    </div>

    <div
      class="bottomBunner"
      :class="{inactive: inactive}"
      v-if="bottomBunner && displayBunner">
      <img
        :src="getImg(bottomBunner.imgPath)"
        @click="onCampaign(bottomBunner.type, bottomBunner.optionId01, bottomBunner.url)">
    </div>

    <Dialog v-if="isOpenAgreedTerms !== 'true' && hasReceiveCoupon">
      <div v-for="(item, index) in receiveCoupon" :key="index">
        <template v-if="couponLength === index+1">
          <div class="dialog-title">クーポンGET！</div>
          <div class="coupon-wrapper">
            <coupon
              class="coupon"
              :image-path="item.imagePath"
              :advertise = "item.advertise"
              :start-time="item.startTime"
              :end-time="item.endTime"
              :use-num="item.useNum"
              :description="item.description"
              :kind="item.kind"
            ></coupon>
          </div>
          <div class="dialog-text">クーポンページから確認してね！</div>
          <normal-btn v-if="receiveCoupon.length === couponLength" @click="hasReceiveCoupon = false">閉じる</normal-btn>
          <normal-btn v-else @click="couponLength = couponLength + 1">次へ</normal-btn>
        </template>
      </div>
    </Dialog>
    <Dialog v-if="isOpenAgreedTerms !== 'true' && isOkOpenDialog && !hasReceiveCoupon">
      <div class="dialog-wrapper">
        <p v-if="hasReceivePitCoupon && informationList.length > 0" class="dialog-text">{{informationList[0]}}</p>
        <div v-else class="dialog-text --normalwrap">
          <template v-for="(list, i) in informationList">
            <div :key="i" class="pitInfoWrapper">
              <p v-if="list !== ''" v-html="list" class="pitInfoText"></p>
              <img v-if="imagePathList[i] !== ''" class="pitInfoImage" :width="pitImageWidthInfo[i]" :src="getImg(imagePathList[i])" alt="">
            </div>
          </template>
        </div>
      </div>
      <button class="closeBtn" @click="closePitDialog()"></button>
      <normal-btn v-if="dialogType !== 0 && !hasReceivePitCoupon && checkIOS() === false" id="onPitButton" @click="onPit">Prize ONを開く</normal-btn>
      <normal-btn v-if="dialogType !== 0 && !hasReceivePitCoupon && checkIOS()" class="appStoreButton" @click="onPitInstall">Prize ONをインストールする</normal-btn>
      <normal-btn v-if="dialogType !== 0 && !hasReceivePitCoupon && checkIOS()" @click="onPitIos">Prize ONを開く</normal-btn>
      <p v-if="dialogType !== 0 && !hasReceivePitCoupon && checkIOS()" class="onPitCaution">インストールがお済みの方はこちら</p>
      <normal-btn v-if="dialogType === 0 && !hasReceivePitCoupon" @click="closePitDialog()">閉じる</normal-btn>
    </Dialog>
    <Dialog v-if="isOpenAgreedTerms !== 'true' && hasAppli && !hasReceiveCoupon && !isOkOpenDialog">
      <div v-for="(item, index) in appliData" :key="index">
        <template v-if="index === current">
          <div class="dialog-imgArea">
            <img :src="getImg(item.imgPath)">
          </div>
        </template>
      </div>
      <button class="closeBtn" @click="hasAppli = false, current = 0"></button>
      <div class="dialog-buttonArea">
        <sub-btn v-if="current >= 1" @click="onPrev">前へ</sub-btn>
        <normal-btn v-if="current <= 3" @click="onNext">次へ</normal-btn>
      </div>
      <normal-btn class="getAppli" @click="onAppStore">アプリをダウンロードする</normal-btn>
    </Dialog>
    <Dialog v-if="isOpenAgreedTerms === 'true'">
      <div class="dialogWrapper">
        <div class="dialogTopWrapper">
          <div class="dialogTitle">
            利用規約を更新しました
          </div>
          <div class="dialogText">
            <p>プリクラONのご利用にあたり、<br>利用規約に同意していただく必要があります。</p>
          </div>
        </div>
        <div class="dialogBtn">
          <label for="agreement" class="checkBox">
            <input type="checkbox" name="agreement" class="checkBox__input" id="agreement" :checked="isChecked" />
            <span class="checkBox__custom" :class="{checkMark: isChecked}" @click="toggleAgree()"></span>
            <span class="checkBox__terms" @click="onAgreeTerms()">利用規約</span>
            に同意する
          </label>
          <normal-btn @click="closeTermsDialog()" :disabled="!isChecked">閉じる</normal-btn>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import Protobuf from '../mixins/protobuf';
import MaintenanceCheck from '../mixins/maintenancecheck';
import SectionHeader from '../components/SectionHeader.vue'
import NormalBtn from '../components/NormalBtn.vue'
import SubBtn from '../components/SubBtn.vue'
import NewsListItem from '../components/NewsListItem.vue'
import Dialog from '../components/Dialog'
import Coupon from "../components/Coupon"
import { isIOS, isAndroid } from '../assets/js/util';
const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web
export default {
  components: { SectionHeader, NormalBtn, SubBtn, NewsListItem, Dialog, Coupon },
  mixins: [Protobuf, MaintenanceCheck],
  data () {
    return {
      newsNum: 0,
      newsList: null,
      messageNum: 0,
      messageList: null,
      couponNum: 0,
      login: false,
      oshirase: false,
      friendCampaignInfo: null,
      campaignList: null,
      topBunner: null,
      bottomBunner: null,
      hasReceiveCoupon: false,
      receiveCoupon: [],
      couponLength: 1,
      hasAppli: false,
      current: 0,
      inactive: false,
      displayBunner: false, // 画面右下バナー表示判定用
      isOkOpenDialog: false,
      informationList: null,
      imagePathList: null,
      informationToPit: null,
      imagePathToPit: null,
      bannerImagePath: null,
      buttonUrl: '',
      dialogType: 0,
      campId: 1,
      hasReceivePitCoupon: false,
      mainVisual: [],
      purikiList: [],
      appliData: [],
      pitImageWidthInfo: [], // PIT連携ダイアログ内の画像の横幅を格納
      termOfServiceNo: 0, // 最後に同意した利用規約のナンバー
      isChecked: false,
      isOpenAgreedTerms: '',
    }
  },
  computed: {
    isLogin() {
      return this.$store.getters.isLogin
    },
  },
  methods: {
    isNew(startdate) {
      const n = 1
      const date = new Date()
      date.setDate(date.getDate() - n)
      return new Date(startdate * 1000) > date
    },
    onAboutApplication() {
      this.$router.push('/AboutApplication')
    },
    onMessageList() {
      this.$router.push('/MessageList')
    },
    onNewsList() {
      this.$router.push('/newsList')
    },
    onNewsDetail(id) {
      this.$router.push({ name: 'newsDetail', params: { id: id } })
    },
    onMessageDetail(id) {
      this.$router.push({ name: 'MessageDetail', params: { id: id } })
    },
    onCouponList() {
      this.$router.push('/couponList')
    },
    onMember() {
      this.$router.push('/member')
    },
    onLogin() {
      this.$router.push('/login')
    },
    onQuestionary() {
      this.$router.push('/Questionary')
    },
    onNewsbanner() {
      this.$router.push('/newsDetail/30')
    },
    onLocation() {
      window.open('https://puri.sega.jp/location-map/', '_blank')
    },
    gradient(strColor) {
      this.contentStyle.background = `linear-gradient(-45deg, ${strColor})`
    },
    onKoutaiLink(url) {
      window.open(url, '_blank')
    },
    closePitDialog() {
      this.isOkOpenDialog = false
      this.setDialogInfo(this.campId, false, this.dialogType)
    },
    /**
     * 一緒にプリクラ！キャンペーンTOPに戻る
     */
    onCampaign(type, id, url) {
      switch(type) {
        case 1: this.$router.push("/friendCampaign"); break;
        case 2: this.$router.push({ name: 'newsDetail', params: { id: id } }); break;
        case 6:
          if(!this.inactive) return
          this.$router.push("/MemberBenefits");
          break;
        case 7:
          sessionStorage.setItem('questionaryUrl', url)
          this.$router.push("/Questionary");
          break;
        case 8:
          window.open(url, '_blank')
          break;
      }
    },
    /**
     * 一緒にプリクラ！キャンペーン開催ステータス取得
     */
    async getCampaignInfo() {
      const cmdNo = pb.CampaignFriendPointReq.CommandNo.COMMAND_NO
      const message = pb.CampaignFriendPointReq.create()
      const encoded = pb.CampaignFriendPointReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          this.friendCampaignInfo = decoded
        })
    },
    /**
     * キャンペーンリスト取得
     */
    async getAnnounce() {
      const cmdNo = pb.AnnounceReq.CommandNo.COMMAND_NO
      const message = pb.AnnounceReq.create()
      const encoded = pb.AnnounceReq.encode(message).finish()

      this.post(cmdNo, encoded)
        .then(decoded => {
          this.campaignList = decoded.announces.filter(item => item.displayLocation === 2)
          this.topBunner = decoded.announces.find(item => !item.displayLocation)
          this.bottomBunner = decoded.announces.find(item => item.displayLocation === 1)
        })
    },

    // みんなへのお知らせ
    async setNewsCount() {
      const cmdNo = pb.NewsListReq.CommandNo.COMMAND_NO
      const message = pb.NewsListReq.create({
        type: 1
      })
      const encoded = pb.NewsListReq.encode(message).finish()
      try {
        const decoded = await this.post(cmdNo, encoded)
        this.newsNum = decoded.newsList.length
        this.newsList = decoded.newsList
      } catch (e) {
        this.newsNum = 0
      }
    },

    // あなたへのお知らせ
    async setMessageCount() {
      const cmdNo = pb.NewsListReq.CommandNo.COMMAND_NO
      const message = pb.NewsListReq.create({
        type: 2
      })
      const encoded = pb.NewsListReq.encode(message).finish()
      try {
        const decoded = await this.post(cmdNo, encoded)
        this.messageNum = decoded.newsList.length
        this.mesageList = decoded.newsList.filter(news => news.startDate < 1861887600)
        const notOpenedNews = decoded.newsList.find(item => !item.isOpen)
        if(!this.isLogin || !decoded.newsList.length || notOpenedNews === undefined){
          this.oshirase = false;
        } else {
          this.oshirase = true;
        }
      } catch (e) {
        this.newsNum = 0
      }
    },

    // メインビジュアル
    async getMainvisual() {
      const cmdNo = pb.KumaMasterSettingReq.CommandNo.COMMAND_NO
      const message = pb.KumaMasterSettingReq.create()
      const encoded = pb.KumaMasterSettingReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          this.mainVisual = decoded.masterMainVisualImgList
          this.purikiList = decoded.masterArcadeList.filter(item => item.isDisplayTop).reverse()
          this.appliData = decoded.masterTutorialList.slice(10, 15)
          this.purikiList.sort((a, b) => {
            if(a.displayOrder < b.displayOrder){
              return 1
            } else if(a.displayOrder > b.displayOrder){
              return -1
            }
          })
        })
    },

    async setCouponCount() {
      const cmdNo = pb.CouponListReq.CommandNo.COMMAND_NO
      const message = pb.CouponListReq.create()
      const encoded = pb.CouponListReq.encode(message).finish()
      try {
        const decoded = await this.post(cmdNo, encoded)
        this.couponNum = decoded.coupons.length
      } catch (e) {
        this.couponNum = 0
      }
    },
    getImg(img) {
      return process.env.VUE_APP_STATIC_CONTENT_SERVER_URL + img
    },
    getCoupon() {
      const cmdNo = pb.BonusReq.CommandNo.COMMAND_NO
      const message = pb.BonusReq.create()
      const encoded = pb.BonusReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          if (decoded.status === pb.BonusResp.Status.SUCCESS) {
            this.receiveCoupon = decoded.items;
            if(this.receiveCoupon && this.receiveCoupon.length) {
              this.hasReceiveCoupon = true;
            }
          } else {
            this.$_error('Error', { title: 'クーポン', statusCode: 470 })
          }
        })
        .catch(() => {
          this.$_error('Error', { title: 'クーポン', statusCode: 100 })
        })
    },
    onNext() {
      this.current++
      window.scrollTo(0,0)
    },
    onPrev() {
      this.current = this.current -1
      window.scrollTo(0,0)
    },
    onAppStore() {
      this.hasAppli = false;
      this.current = 0;
      window.open('https://app.adjust.com/g01bn92', '_blank')
    },
    onPit(){
      if(isAndroid()){
        location.href = this.buttonUrl
        setTimeout(() => {
          location.href = 'https://play.google.com/store/apps/details?id=com.sega.pit'
        }, 5000)
      } else {
        this.$router.push('/EnvironmentAttention')
      }
    },
    onPitIos(){
      location.href = this.buttonUrl
    },
    onPitInstall(){
      location.href = 'https://apps.apple.com/jp/app/prize-on/id1571601446'
    },
    checkIOS(){
      return isIOS()
    },
    async getPitInfo(){
      const cmdNo = pb.PlayerCampPitInfoReq.CommandNo.COMMAND_NO
      const message = pb.PlayerCampPitInfoReq.create()
      const encoded = pb.PlayerCampPitInfoReq.encode(message).finish()

      this.post(cmdNo, encoded)
        .then(decoded => {
            if (decoded.status === pb.PlayerCampPitInfoResp.Status.SUCCESS) {
              this.informationList = decoded.informationList
              this.imagePathList = decoded.imagePathList
              this.informationToPit = decoded.informationToPit
              this.imagePathToPit = decoded.imagePathToPit
              this.bannerImagePath = decoded.bannerImagePath
              this.buttonUrl = decoded.buttonUrl
              this.dialogType = decoded.dialogType
              this.campId = decoded.campId

              this.isOkOpenDialog = decoded.isOkOpenDialog

              // 対象のキャンペーンのダイアログ情報を取得
              const targetDialogInfo = JSON.parse(localStorage.getItem(`dialogInfo${decoded.campId}`))

              if(decoded.dialogType < 0 || decoded.dialogType > 2){
                // クーポン受け取り資格がないのでダイアログは非表示
                this.isOkOpenDialog = false
              } else if(targetDialogInfo === null && decoded.dialogType >= 0 && decoded.dialogType <= 2){
                // 初めてダイアログを表示する場合
                this.setDialogInfo(decoded.campId, decoded.isOkOpenDialog, decoded.dialogType)
              } else if(targetDialogInfo && targetDialogInfo.dialogType === decoded.dialogType){
                // ダイアログの種類（キャンペーン期間）が変わっていないのでlocalstorageの中身維持
                this.isOkOpenDialog = targetDialogInfo.isOkOpenDialog
              } else if(targetDialogInfo && targetDialogInfo.dialogType !== decoded.dialogType && decoded.dialogType >= 0 && decoded.dialogType <= 2){
                // ダイアログの種類（キャンペーン期間）が変わったので再度セット
                this.setDialogInfo(decoded.campId, decoded.isOkOpenDialog, decoded.dialogType)
              } else {
                this.setDialogInfo(decoded.campId, decoded.isOkOpenDialog, decoded.dialogType)
              }
              this.setPitImageSize(decoded.imagePathList)
            }
        })
    },
    setDialogInfo(campId, isOkOpenDialog, dialogType){
      const dialogInfo = {
        'isOkOpenDialog': isOkOpenDialog,
        'dialogType': dialogType,
      }
      localStorage.setItem(`dialogInfo${campId}`, JSON.stringify(dialogInfo))
    },
    async openPitDialog(){
        const cmdNo = pb.PlayerCampPitInfoReq.CommandNo.COMMAND_NO
        const message = pb.PlayerCampPitInfoReq.create()
        const encoded = pb.PlayerCampPitInfoReq.encode(message).finish()

        this.post(cmdNo, encoded)
          .then(decoded => {
            if (decoded.status === pb.PlayerCampPitInfoResp.Status.SUCCESS) {
              this.informationList = decoded.informationList
              this.imagePathList = decoded.imagePathList
              this.informationToPit = decoded.informationToPit
              this.imagePathToPit = decoded.imagePathToPit
              this.bannerImagePath = decoded.bannerImagePath
              this.buttonUrl = decoded.buttonUrl
              this.dialogType = decoded.dialogType
              this.campId = decoded.campId

              this.isOkOpenDialog = true
              this.hasReceivePitCoupon = false

              // PITクーポンを受け取り済みか開催期間外の時
              if(!decoded.isOkOpenDialog){
                this.hasReceivePitCoupon = true
                this.dialogType = 0
              }

              this.setPitImageSize(decoded.imagePathList)
            }
          })
    },
    getMainvisualStyle(index, imgPath, length) {
      return `
        background-image: url(${this.getImg(imgPath)});
        animation: mainvisual${length} ${length * 4}s ease infinite 0s;
        animation-delay: ${index * 4}s;
      `
    },
    // PIT連携ダイアログ内の画像のサイズ調整
    async setPitImageSize(imagePathList){
        let imagesInfo = []
        for (let i = 0; i < imagePathList.length; i++) {
          if(imagePathList[i] === ''){
            imagesInfo.push('')
            continue;
          }else {
            const imageRes = await this.getImageInfo(imagePathList,i)
              .then(res => res)
            if(imageRes && imageRes.naturalWidth >= 800){
              imagesInfo.push(imageRes.naturalWidth)
            } else if(imageRes && imageRes.naturalWidth < 800){
              // 横幅800px未満の画像はアプリ側の表示に合わせるためサイズを小さく
              const halfWidth = imageRes.naturalWidth / 2.8
              imagesInfo.push(halfWidth)
            } else {
              imagesInfo.push('')
            }
          }
        }
        // PIT連携画像の横幅をまとめて格納
        Promise.all(imagesInfo).then(res => {
          this.pitImageWidthInfo = res;
        })
    },
    // 画像の情報を取得
    async getImageInfo(imagePathList, i){
      return new Promise((resolve, reject) => {
        const targetSrc = this.getImg(imagePathList[i])
        const img = new Image()
        img.src = targetSrc
        img.onload = () => {
          resolve(img)
        }
        img.onerror = (error) => {
          reject(error)
        }
      })
    },
    // チェックボタン用
    toggleAgree(){
      this.isChecked = !this.isChecked;
    },
    onAgreeTerms() {
      this.$router.push("/terms")
    },
    closeTermsDialog(){
      localStorage.setItem('isAgreedTerms', false);
      this.isOpenAgreedTerms = 'false'

      const cmdNo = pb.KumaMasterSettingReq.CommandNo.COMMAND_NO
      const message = pb.KumaMasterSettingReq.create()
      const encoded = pb.KumaMasterSettingReq.encode(message).finish()
      this.post(cmdNo, encoded).then(decoded => {
        const cmdNo2 = pb.PlayerGeneralInformationReq.CommandNo.COMMAND_NO
        const message2 = pb.PlayerGeneralInformationReq.create({
          informationId: 1,
          isSave: true,
          intInformation: decoded.termsOfServiceNo,
        })
        const encoded2 = pb.PlayerGeneralInformationReq.encode(message2).finish()
        this.post(cmdNo2, encoded2)
      })
    },
  },
  mounted () {
    this.maintenanceCheck();
    if (this.isLogin) {
      this.isOpenAgreedTerms = localStorage.getItem('isAgreedTerms')
      this.getCampaignInfo()
      this.setCouponCount()
      this.getCoupon()
      this.getPitInfo()
      this.login = true;
      const date = new Date();
      sessionStorage.setItem('prevPage', '/');
      if(Number(localStorage.getItem('date')) > date.getTime()) {
        this.hasAppli = false;
      } else {
        this.hasAppli = true;
        localStorage.setItem('date', date.setDate(date.getDate() + 1));
      }
    }
    // バナー表示用
    window.addEventListener('scroll', () => {
      const scroll = window.scrollY
      scroll > 220 ? this.displayBunner = true : this.displayBunner = false
      scroll > 225 ? this.inactive = true : this.inactive = false
    })
    this.getAnnounce()
    this.setNewsCount()
    this.setMessageCount()
    this.getMainvisual()
  }
}
</script>
<style lang="scss">
.allContainer {
  background-color: #F5F4F4;
}
.homeContent {
  background-color: #F5F4F4;
  .SectionHeader {
    padding: 0 15px;
  }
  .topNews {
    display:  flex;
    justify-content: center;
    align-items: center;
    padding: 5px 0;
    font-size: .8em;
    background-color: #EF2562;
    color: #fff;
    text-align: center;
    &::before {
      content: "";
      display: block;
      width: 1.6em;
      height: 1.6em;
      margin-right: 5px;
      background-image: url(../assets/Png/top/image_message_white.png);
      background-size: contain;
      background-position: center;
    }
  }
  .mainvisual {
    position: relative;
    height: 420px;
    .bg {
      position: absolute;
      top: 0;
      width: 100%;
      height: 420px;
      background-size: 100% auto;
      opacity: 0;
      will-change: opacity;
    }
    .--opacityOne {
      opacity: 1;
    }
  }
  .topBunner {
    background-color: #F5F4F4;
    padding: 15px 15px 0;
    img {
      width: 345px;
      height: auto;
    }
  }
  .storeLink {
    margin-top: 20px;
    padding: 20px;
    background-color: #FBFCFD;
    display: flex;
    justify-content: space-between;
    .appstore,
    .googleplay {
      width: auto;
      height: 50px;
    }
  }
  .appliText {
    padding-bottom: 20px;
    background-color: #FBFCFD;
    font-size: 12px;
    color: #373737;
    &-inner { padding: 0 20px; }
  }
  .campaign,
  .news,
  .puriki {
    margin-top: 20px;
    padding-bottom: 20px;
    background-color: #FBFCFD;
  }
  .campaignArea {
    width: 375px;
    overflow-x: scroll;
  }
  .campaignList {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    padding: 0 15px;
    li {
      list-style: none;
      &:not(:first-child) { margin-left: 5px; }
      width: 50%;
      button {
        img {
          width: 100%;
          height: auto;
        }
      }
    }
  }
  .purikiArea {
    margin-top: 10px;
    overflow-x: scroll;
  }
  .purikiTitle {
    display: flex;
    justify-content: space-between;
    .linkText {
      margin: 15px;
      padding-right: 30px;
      text-align: right;
      font-size: 10px;
      color: #F63C5B;
      background-image:
        linear-gradient(to left, #F63C5B, #F63C5B),
        linear-gradient(45deg, transparent 47%, #F63C5B 49%, #F63C5B 51%, transparent 53%);
      background-repeat: no-repeat;
      background-size: 24px 1px, 8px 8px;
      background-position: right 70%, right 40%;
    }
  }
  .purikiList {
    display: flex;
    justify-content: center;
    padding: 0 15px;
    li {
      width: 30%;
      text-align: center;
      font-size: 12px;
      color: #4B4344;
      list-style: none;
      &:not(:first-child) { margin-left: 5px; }
      .puriBtn {
        padding: 15px 0 10px;
        border: 1px solid #E1DADB;
        border-radius: 12px;
        &.comingsoon {
          background-image: url(../assets/Png/top/mainvisual_comingsoon2.png);
          background-size: auto 15px;
          background-position: 2px 2px;
        }
        &.new {
          background-image: url(../assets/Png/top/image_news_new.png);
          background-size: auto 15px;
          background-position: 2px 2px;
        }
        &.end {
          background-image: url(../assets/Png/top/ic_kyoutai_end.png);
          background-size: auto 15px;
          background-position: 2px 2px;
        }
      }
      img {
        width: 80%;
        height: auto;
      }
      .puriTitle { margin-top: 10px; }
    }
  }

  .bottomBunner {
    position: fixed;
    bottom: 60px;
    left: 50%;
    opacity: 0;
    transition: .3s;
    &.inactive {
      opacity: 1;
    }
    img {
      width: 174px;
      height: auto;
    }
  }

  .dialog {
    .coupon-wrapper { margin-top: 20px; }
    &-wrapper {
      width: 100%;
      height: 400px;
      margin-top: 20px;
      color: #373737;
      overflow-y: scroll;
    }
    &-title {
      text-align: center;
      font-weight: bold;
      color: #F63C5B;
      &.appli { color: #4B4344; }
    }
    &-imgArea {
      margin-top: 20px;
      img {
        width: 315px;
        height: auto;
      }
    }
    &-kind {
      margin-top: 10px;
      font-size: 12px;
      color: #F63C5B;
    }
    &-data {
      margin-top: 5px;
      font-size: 12px;
      color: #DA2240;
    }
    &-text {
      margin-top: 5px;
      font-size: 12px;
      color: 373737;
      white-space: pre;

      .pitInfoWrapper {
        width: 90%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;

        .pitInfoText {
          width: 100%;
        }

        .pitInfoImage {
          max-width: 100%;
        }
      }
    }
    .--normalwrap {
      white-space: normal;
    }
    .locationLink {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
      color: #373737;
      button {
        font-size: 10px;
        font-weight: bold;
        & > img {
          width: 60px;
          height: auto;
        }
      }
    }
    &-buttonArea {
      display: flex;
    }
    .NormalBtn {
      margin: 20px 0 0 0;
      & > a {
        text-decoration: none;
        display: block;
        color: #fff;
      }
      &.getAppli {
        position: relative;
        &::before {
          content: "";
          display: block;
          position: absolute;
          top: 10px;
          left: 20px;
          width: 38px;
          height: 38px;
          background-image: url(../assets/Png/Application/image_icon_app.png);
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
        }
        &::after {
          content: "";
          display: block;
          position: absolute;
          top: -10px;
          right: 20px;
          width: 54px;
          height: 28px;
          background-image: url(../assets/Png/Application/ic_free.png);
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
        }
      }
    }
    .SubBtn { margin: 20px 15px 0 0; }
    .appStoreButton {
      margin-top: 15px;
    }
    .onPitCaution {
      font-size: 14px;
      text-align: center;
    }

    .dialogInner {
      .dialogWrapper {
        width: 100%;
        height: 300px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .dialogTopWrapper {
          height: 200px;

          .dialogTitle {
            font-size: 18px;
            height: 25px;
            text-align: center;
          }
          .dialogText {
            font-size: 12px;
            height: 175px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #373737;
            text-align: start;
          }
        }
        .dialogBtn {
          height: 100px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .checkBox {
            margin: 10px auto 0;
            width: fit-content;
            display: flex;
            justify-content: center;
            align-items: center;
            user-select: none;

            &__input {
              display: none;
            }

            &__custom {
              margin-right: 10px;
              display: block;
              position: relative;
              border: 1px solid #000;
              border-radius: 30%;
              width: 20px;
              height: 20px;
              cursor: pointer;

              &::before {
                content: '';
                position: absolute;
                width: 7px;
                height: 10px;
                top: 10%;
                left: 33%;
                border: 2px solid #000;
                border-top: none;
                border-left: none;
                transform: rotate(45deg);
                opacity: 0;
              }
            }
            .checkMark {
              &::before {
                content: '';
                opacity: 1;
              }
            }

            &__terms {
              color: #F63C5B;
              text-decoration: underline;
              cursor: pointer;
            }
          }
          & > .NormalBtn {
            margin: 10px 0px 0;
            width: 60%;

            &:disabled {
              background-color: #F63C5B;
              opacity: 0.5;
              color: #fff;
            }
          }
        }
      }
    }
  }
}

// メインビジュアルの枚数によってキーフレームを切り替え
@keyframes mainvisual2{
  0% { opacity: 0; }
  5% { opacity: 1; }
  50% { opacity: 1; }
  55% { opacity: 0; }
  100% { opacity: 0; }
}

@keyframes mainvisual3{
  0% { opacity: 0; }
  5% { opacity: 1; }
  35% { opacity: 1; }
  40% { opacity: 0; }
  100% { opacity: 0; }
}

@keyframes mainvisual4{
  0% { opacity: 0; }
  5% { opacity: 1; }
  25% { opacity: 1; }
  30% { opacity: 0; }
  100% { opacity: 0; }
}

@keyframes mainvisual5{
  0% { opacity: 0; }
  5% { opacity: 1; }
  20% { opacity: 1; }
  25% { opacity: 0; }
  100% { opacity: 0; }
}

@keyframes mainvisual6{
  0% { opacity: 0; }
  5% { opacity: 1; }
  16% { opacity: 1; }
  20% { opacity: 0; }
  100% { opacity: 0; }
}

@keyframes mainvisual7{
  0% { opacity: 0; }
  5% { opacity: 1; }
  14% { opacity: 1; }
  18% { opacity: 0; }
  100% { opacity: 0; }
}

@keyframes mainvisual8{
  0% { opacity: 0; }
  5% { opacity: 1; }
  12% { opacity: 1; }
  16% { opacity: 0; }
  100% { opacity: 0; }
}

@keyframes mainvisual9{
  0% { opacity: 0; }
  5% { opacity: 1; }
  10% { opacity: 1; }
  14% { opacity: 0; }
  100% { opacity: 0; }
}

@keyframes mainvisual10{
  0% { opacity: 0; }
  5% { opacity: 1; }
  9% { opacity: 1; }
  13% { opacity: 0; }
  100% { opacity: 0; }
}
</style>
